// extracted by mini-css-extract-plugin
export default {"title":"delete_title__iJu8u","buttonPart":"delete_buttonPart__-LGJ8","buttonCancel":"delete_buttonCancel__e7TXR","buttonDelete":"delete_buttonDelete__tngrr"};